import { TSwapPlayers } from '../../../../../../store/admin/eventRounds/actions';

import { isMobileResolution } from '../../../../../../contrib/utils';
import { IStateDispatchActions } from '../TeeSheetCreator.context';

const isMobile = isMobileResolution();

interface IOnSelectPlayerToSwapAugmentedArgs {
  swapPlayers: TSwapPlayers;
  clubId: string | undefined;
  roundId: string | undefined;
  eventId: string | undefined;
}

export type IOnSelectPlayerToSwap = (enrollmentId: number) => () => Promise<any>;

type IOnSelectPlayerToSwapAugmented = (
  args: IOnSelectPlayerToSwapAugmentedArgs
) => IOnSelectPlayerToSwap;

export const onSelectPlayerToSwap: IStateDispatchActions<IOnSelectPlayerToSwapAugmented> = (
  state,
  dispatch
) => args => (enrollmentId: number) => async () => {
  const { swapPlayers, clubId, roundId, eventId } = args;
  const { selectedPlayer } = state;

  if (!selectedPlayer) {
    return;
  }

  if (isMobile) {
    dispatch({ type: 'set', value: { attribute: 'modalOpen', value: false } });
    dispatch({ type: 'set', value: { attribute: 'searchValue', value: '' } });
  }

  swapPlayers(Number(clubId), Number(eventId), Number(roundId), selectedPlayer, enrollmentId);

  dispatch({ type: 'set', value: { attribute: 'selectedGroup', value: 0 } });
  dispatch({ type: 'set', value: { attribute: 'selectedPlayer', value: 0 } });
  dispatch({ type: 'set', value: { attribute: 'selectedSeat', value: 0 } });
  dispatch({ type: 'set', value: { attribute: 'selectedSwap', value: 0 } });
};
